
const state = {
    CsfcLoading: false
}

const getters = {
    CsfcLoading(state){
        return state.CsfcLoading;
    }
}

const mutations = {
    showCSFCloader: state => state.CsfcLoading = true,
    hideCSFCloader: state => state.CsfcLoading = false
}

const actions = {
    showCSFCloader: ({commit}) => {
        commit('showCSFCloader');
    },
    hideCSFCloader: ({commit}) => {
        commit('hideCSFCloader');
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/CSFCloading.js